import React from 'react';
import { motion } from 'framer-motion';

interface Partner {
  name: string;
  logo: string;
  noInvert?: boolean;
}

const partners: Partner[] = [
  { name: 'Pellago', logo: '/logos/pellago.webp' },
  { name: 'Investland Bali', logo: '/logos/investland-bali.webp' },
  { name: 'Luup Design', logo: '/logos/luup-design.png' },
  { name: 'Constructland Indonesia', logo: '/logos/constructland.png' },
  { name: 'Diil', logo: '/logos/diil-logo.svg' },
  { name: 'ROI Calculate', logo: '/logos/roi-calculate.png', noInvert: true },
];

export const PartnersSection: React.FC = () => {
  // Duplicate the partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners, ...partners, ...partners];

  return (
    <section className="relative py-12 bg-[#0a0a0a] overflow-hidden">
      {/* Top border line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-zinc-500 text-sm uppercase tracking-wider mb-8"
        >
          Trusted by innovative companies
        </motion.p>

        {/* Infinite scroll container */}
        <div className="relative">
          {/* Gradient masks for fade effect */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10 pointer-events-none" />

          {/* Scrolling track */}
          <div className="overflow-hidden">
            <motion.div
              className="flex items-center gap-16"
              animate={{
                x: ['0%', '-50%'],
              }}
              transition={{
                x: {
                  duration: 30,
                  repeat: Infinity,
                  ease: 'linear',
                },
              }}
            >
              {duplicatedPartners.map((partner, index) => (
                <div
                  key={`${partner.name}-${index}`}
                  className="flex-shrink-0 flex items-center justify-center h-12 px-4 opacity-50 hover:opacity-80 transition-all duration-300"
                >
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className={`h-full w-auto max-w-[160px] object-contain ${partner.noInvert ? '' : 'brightness-0 invert'}`}
                  />
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>

      {/* Bottom border line */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />
    </section>
  );
};

export default PartnersSection;
